<template>
  <div :id="componentId" class="spm1-top-banner" :style="wrapperStyle">
    <div class="spm1-nav-scroll">
      <a
        v-for="(item, idx) in navItems"
        :key="idx"
        :class="['spm1-nav-item', { active: activeIndex === idx }]"
        :style="getItemStyle(idx)"
        href="javascript:;"
        @click.prevent="handleClick(idx, item)"
      >
        {{ item.label }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileTopBanner',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_1'
    }
  },
  data() {
    return {
      activeIndex: 0,
      backgroundColor: '#FFFFF0',
      fontColor: 'rgba(51, 51, 51, 1)',
      selectedFontColor: 'rgba(255, 255, 255, 1)',
      selectedModuleColor: 'rgba(9, 79, 70, 1)',
      navItems: [
        { label: '专题介绍', type: 1, value: 'top' },
        { label: '系列活动', type: 1, value: 'module_4' },
        { label: '大会亮点', type: 1, value: 'module_5' },
        { label: '大会嘉宾', type: 1, value: 'module_6' },
        { label: '大会议程', type: 1, value: 'module_7' },
        { label: '大会地址', type: 1, value: 'module_8' },
        { label: '大会主持', type: 1, value: 'module_9' },
        { label: '核心活动', type: 1, value: 'module_10' },
        { label: '精彩回顾', type: 1, value: 'module_11' },
        { label: '年度盛典', type: 1, value: 'module_12' },
        { label: '组织机构', type: 1, value: 'module_13' },
        { label: '合作品牌', type: 1, value: 'module_14' },
        { label: '媒体合作', type: 2, value: 'https://www.baidu.com' }
      ]
    }
  },
  computed: {
    wrapperStyle() {
      return {
        backgroundColor: this.backgroundColor
      }
    }
  },
  mounted() {
    this.onScroll()
    window.addEventListener('scroll', this.throttledScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.throttledScroll)
  },
  methods: {
    getItemStyle(idx) {
      const isActive = this.activeIndex === idx
      return {
        color: isActive ? this.selectedFontColor : this.fontColor,
        backgroundColor: isActive ? this.selectedModuleColor : 'transparent'
      }
    },
    handleClick(idx, item) {
      this.activeIndex = idx
      if (item.type === 2) {
        window.open(item.value, '_blank')
        return
      }
      if (item.value === 'top') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        return
      }
      const el = document.getElementById(item.value)
      if (!el) return
      const headerOffset = 48
      const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset
      window.scrollTo({ top, behavior: 'smooth' })
    },
    throttledScroll() {
      if (this.scrollTimer) return
      this.scrollTimer = setTimeout(() => {
        this.scrollTimer = null
        this.onScroll()
      }, 100)
    },
    onScroll() {
      const scrollTop = window.pageYOffset
      const viewportHeight = window.innerHeight
      const docHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      const isBottom = scrollTop + viewportHeight >= docHeight - 20
      if (isBottom) {
        this.activeIndex = this.navItems.length - 1
        return
      }
      const headerOffset = 80
      let activeIndex = 0
      for (let i = this.navItems.length - 1; i >= 0; i--) {
        const item = this.navItems[i]
        if (item.type !== 1 || item.value === 'top') continue
        const el = document.getElementById(item.value)
        if (!el) continue
        const sectionTop = el.getBoundingClientRect().top + window.pageYOffset
        if (sectionTop - headerOffset <= scrollTop) {
          activeIndex = i
          break
        }
      }
      this.activeIndex = activeIndex
    }
  }
}
</script>

<style scoped>
.spm1-top-banner {
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 100;
}

.spm1-nav-scroll {
  display: flex;
  align-items: center;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 8px;
  height: 44px;
  gap: 4px;
  scrollbar-width: none;
}

.spm1-nav-scroll::-webkit-scrollbar {
  display: none;
}

.spm1-nav-item {
  flex-shrink: 0;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
  font-size: 13px;
  font-family: Microsoft YaHei-Regular;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 16px;
}

.spm1-nav-item:hover {
  opacity: 0.85;
}
</style>
